import { render, staticRenderFns } from "./wechat_callback.vue?vue&type=template&id=256ae761&scoped=true"
import script from "./wechat_callback.vue?vue&type=script&lang=js"
export * from "./wechat_callback.vue?vue&type=script&lang=js"
import style0 from "./wechat_callback.vue?vue&type=style&index=0&id=256ae761&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256ae761",
  null
  
)

export default component.exports